import { render, staticRenderFns } from "./GSelectBoxString.vue?vue&type=template&id=2d169d15&scoped=true&"
import script from "./GSelectBoxString.vue?vue&type=script&lang=ts&"
export * from "./GSelectBoxString.vue?vue&type=script&lang=ts&"
import style0 from "./GSelectBoxString.vue?vue&type=style&index=0&id=2d169d15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d169d15",
  null
  
)

export default component.exports